module.exports = __webpack_public_path__ + "img/wow-active.fc0b63e9.png";